import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import calles from '../filter-three/filtroCalles.json';
import { FormControl } from '@angular/forms';
import { CommonUtilitiesService } from '../../common-utilities.service';
import { Router } from '@angular/router';
import * as inside from 'point-in-polygon';
import * as geolib from 'geolib';

@Component({
  selector: 'app-filter-two',
  templateUrl: './filter-two.component.html',
  styleUrls: ['./filter-two.component.scss']
})
export class FilterTwoComponent implements OnInit {

  viewFilterOne:boolean = false
  viewFilterTwo:boolean = false
  street = []

  //emit
  @Output() dataFilter = new EventEmitter<any>();

  ///variables de modal
  isShowModal = false;
  modalTitle = "";
  modalContent = "";
  isModalReload = false;
  isLoadingBalance:boolean = false;

  //Form
  latitud = new FormControl('');
  longitud = new FormControl('');
  latitudOne = new FormControl('');
  latitudTwo = new FormControl('');
  latitudThree = new FormControl('');
  longitudOne = new FormControl('');
  longitudTwo = new FormControl('');
  longitudThree = new FormControl('');
  zoneLatitud = new FormControl('');
  zoneLongitud = new FormControl('');
  techSelec = new FormControl('');

  constructor(
    private _router: Router, 
    public LANG: CommonUtilitiesService
  ) {}

  ngOnInit() {
    
  }

  /**
   * @author Luis Hernandez
   * @description Metodo que valida cual filtro aplicar si por coordenadas o por G M S
   * @param param 
   */
  selectTypeSearch(param){
    this.viewFilterOne = false
    this.viewFilterTwo = false
    if(param == 1){
      this.viewFilterOne = true
    }else if(param == 2){
      this.viewFilterTwo = true
    }
  }

  /**
   * @author Luis Hernandez
   * @description Metodo que se encarga de validar cual filtro validar, 
   * es decir si validamos los campos por coordenadas o validamos los campos por G M S
   */
  validFilter(){
    if(this.viewFilterOne){
      this.validViewBtnSearchOne()
    }
    if(this.viewFilterTwo){
      this.validViewBtnSearchTwo()
    }
  }


  /**
   * @author Luis Hernandez
   * @description Metodo que se encarga de validar los campos de busqueda por latitud y longitud
   */
  validViewBtnSearchOne(){
    this.isLoadingBalance = true;
    if(this.latitud.value != "" && this.longitud.value != "" && this.techSelec.value != ""){
      this.getKmlLocationFilter(this.latitud.value, this.longitud.value, this.techSelec.value)
    }else{
      this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
      this.modalContent = this.LANG.getLangText('PORTABILITY_MODAL_CONTENT_VALIDATION');
      this.isShowModal = true;
      this.isLoadingBalance = false;
    }
  }

  /**
   * @author Luis Hernandez
   * @description Metodo que se encarga de validar los campos de busqueda por G M S
   */
  validViewBtnSearchTwo(){
    if(
      this.latitudOne.value != "" && 
      this.latitudTwo.value != "" && 
      this.latitudThree.value != "" && 
      this.longitudOne.value != "" && 
      this.longitudTwo.value != "" && 
      this.longitudThree.value != "" && 
      this.techSelec.value != "" &&
      this.zoneLatitud.value != "" &&
      this.zoneLongitud.value != ""
      ){
        let lat = this.getCoordenate(this.latitudOne.value, this.latitudTwo.value, this.latitudThree.value, this.zoneLatitud.value);
        let lng = this.getCoordenate(this.longitudOne.value, this.longitudTwo.value, this.longitudThree.value, this.zoneLongitud.value);
        this.getKmlLocationFilter(lat, lng, this.techSelec.value)
    }else{
      this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
      this.modalContent = this.LANG.getLangText('PORTABILITY_MODAL_CONTENT_VALIDATION');
      this.isShowModal = true;
      this.isLoadingBalance = false;
    }
  }



  /**
   * @author Luis Hernandez
   * @description Metodo que busca los kml que hacen referencia segun la tecnologia y las coordenadas
   * @param lat 
   * @param lng 
   * @param tech 
   */
  getKmlLocationFilter(lat, lng, tech){
    let regionGet = ""
    const result = calles.filter(calle => calle.tech == tech);
    for (let el of result[0].data) {
      let itera:any = el
      let dataEvalu = []
      itera.coord.forEach(coord => {let coo = coord.split(","); dataEvalu.push([parseFloat(coo[1]),parseFloat(coo[0])])});
      let searchRegion = inside([parseFloat(lat),parseFloat(lng)], dataEvalu)
      if(searchRegion){
        regionGet = el.region
        break;
      }
    }
    this.isLoadingBalance = false;
    if(regionGet == ""){
      this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
      this.modalContent = this.LANG.getLangText('COVERAGE_MODAL_CONTENT_VALIDATION');
      this.isShowModal = true;
    }else{
      this.street = []
      this.street.push({"filter":2,"data":[],"type":this.techSelec.value,"coord":{"lat":null,"lng":null}})
      this.street[0].data.push(this.LANG.getLangText('URL_PATH_KML')+regionGet+"/"+tech+"/predictions.kml")
      this.street[0].coord.lat = lat
      this.street[0].coord.lng = lng
      this.dataFilter.emit(this.street)
    }
  }

  /**
   * @author Luis Hernandez
   * @description Metodo que devuelve las coordenadas teniendo como entrada GGMMSS (grados-minutos-segundos)
   * @param days 
   * @param minutes 
   * @param seconds 
   * @param direction 
   */
  getCoordenate(days, minutes, seconds, direction) {
    let paramGGMMSS = `${days}°${minutes}'${seconds}"${direction}`;
    return geolib.sexagesimalToDecimal(paramGGMMSS)
  }


  /**
   * Description: Método que ocualta el modal
   * Autor: Luis Hernandez
   * @param N/A
   * @return N/A
   */
  hideModal() {
    this.isShowModal = false;
    if (this.isModalReload) {
      this._router.navigate(['/']);
    } 
  }



}
